import { useHead } from "@unhead/vue";
import { useNuxtApp, callWithNuxt } from "../nuxt.mjs";
export const defineNuxtComponent = function defineNuxtComponent2(...args) {
  const [options, key] = args;
  const { setup, head, ...opts } = options;
  if (!setup && !options.asyncData && !options.head) {
    return {
      ...options
    };
  }
  return {
    _fetchKeyBase: key,
    ...opts,
    setup(props, ctx) {
      const nuxtApp = useNuxtApp();
      const res = setup ? callWithNuxt(nuxtApp, setup, [props, ctx]) : {};
      if (options.head) {
        const nuxtApp2 = useNuxtApp();
        useHead(typeof options.head === "function" ? () => options.head(nuxtApp2) : options.head);
      }
      return res;
    }
  };
};
